import React, { useEffect, useState } from 'react';
import IFormError from '../../../../interfaces/IFormError';
import IWizardStep from '../../../../interfaces/IWizardStep';
import WizardButton from '../../components/WizardButton';
import { WizardContent } from '../../components/WizardContent';
import { WizardSecodaryTitle } from '../../components/WizardSecodaryTitle';
import WizardTextField from '../../components/WizardTextField';
import { WizardTitle } from '../../components/WizardTitle';
import InputMask from 'react-input-mask';
import * as yup from 'yup';
import { useValidateSchema } from '../../../../hooks/providers/useValidateSchema';
import { TestContext } from 'yup';
import { useToastrVanila } from '../../../../hooks/util/useToastrVanila';
import { useWizardRequest } from '../../../../hooks/services/useWizardRequest';

interface ContactProps extends IWizardStep { }

const Contact = (props: ContactProps) => {
  const [loading, setLoading] = useState(false);
  const [phoneNumber, setPhoneNumer] = useState(props.medicalCertificate.phoneNumber || '');
  const [email, setEmail] = useState(props.medicalCertificate.email || '');
  const [errors, setErrors] = useState<IFormError | null>(null);
  const vallidate = useValidateSchema();
  const toastr = useToastrVanila();
  const request = useWizardRequest();

  const schema = yup.object({
    email: yup.string().email('Favor informar um e-mail válido'),
    phoneNumber: yup.string().test((phoneNumber: string = '', schema: TestContext) => {
      const phone = cleanPhoneNumber(phoneNumber);

      if (phone.split('').length > 0 && phone.split('').length < 11) {
        return schema.createError({ message: 'O número não está correto.' });
      }
      return true;
    }),
  });



  const cleanPhoneNumber = (phone: string): string => {
    return phone
      .replaceAll(' ', '')
      .replaceAll('-', '')
      .replaceAll('(', '')
      .replaceAll(')', '')
      .replaceAll('+', '');
  };

  const handleSubmit = async () => {
    if (!phoneNumber.trim() && !email.trim()) {
      toastr.error('Por favor, preencha o e-mail ou telefone.');
      return;
    }

    const result = await vallidate.validate(schema, { phoneNumber, email });
    if (!result.isValid) {
      setErrors({ ...result.errors });
      return;
    }
    setErrors(null);
    setLoading(true);

    const cleanedPhone = cleanPhoneNumber(phoneNumber);
    if (phoneNumber && cleanedPhone.length < 8) {
      toastr.error('Digite um número de telefone válido!');
      setLoading(false);
      return;
    }

    if (email && email.length < 5) {
      toastr.error('Digite um e-mail válido!');
      setLoading(false);
      return;
    }

    try {
      await request.FinishDocument(
        Number(cleanedPhone),
        email,
        3,
        props.medicalCertificate.id!
      );

      await props.setStep(props.step + 1, {
        ...props.medicalCertificate,
        phoneNumber: cleanedPhone,
        email,
        isDraft: false,
      });

    } catch (error) {
      toastr.error('Houve um erro ao enviar a mensagem ou carregar os dados.');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const listEmployeeByID = async (id: number): Promise<void> => {
    setLoading(true);
    await request
      .listEmployeeById(id)
      .then(result => {
        setLoading(false);
        if (result.email) {
          setEmail(result.email.trim());
        }
        if (result.phoneNumber) {
          setPhoneNumer(formatPhone(result.phoneNumber.trim()));
        }
      })
      .catch(error => {
        setLoading(false);
        toastr.error(error.message);
      });
  };

  function formatPhone(phone: string): string {
    const digits = String(phone ?? '').replace(/\D/g, '');
    
    if (digits.length === 13 && digits.startsWith('55')) {
      return digits.slice(2);
    }

    return digits;
  }

  useEffect(() => {
    listEmployeeByID(props.medicalCertificate.employeeId);
  }, []);

  return (
    <WizardContent>
      <WizardTitle marginBotton={2}>Acompanhe o status do seu atestado:</WizardTitle>
      <WizardSecodaryTitle>(Informe seu telefone ou e-mail para acompanhar seu atestado)</WizardSecodaryTitle>
      <form>
        <InputMask
          mask={'(99) 9 9999-9999'}
          value={phoneNumber}
          onChange={e => setPhoneNumer(e.target.value)}
          maskPlaceholder={null}
          style={{ marginBottom: '20px' }}
        >
          <WizardTextField
            label="Telefone"
            placeholder="Informe seu telefone"
            sx={{ marginTop: '15px', width: '300px' }}
            error={Boolean(errors?.phoneNumber)}
            helperText={errors?.phoneNumber}
          />
        </InputMask>
        ou
        <WizardTextField
          label="E-mail"
          placeholder="Informe seu e-mail"
          sx={{ marginTop: '15px', width: '300px' }}
          value={email}
          onChange={e => setEmail(e.target.value)}
          error={Boolean(errors?.email)}
          helperText={errors?.email}
        />
        <WizardButton
          type="submit"
          isLoading={loading}
          disabled={loading}
          sx={{ marginTop: '100px' }}
          onClick={handleSubmit}
        >
          PRÓXIMO
        </WizardButton>
      </form>
    </WizardContent>
  );
};

export default Contact;
